
<template>
  <div class="row d-flex align-items-center mt-0">
    <!-- 🏢 Logo & Version -->
    <div class="col-xl-auto d-flex col-lg-auto col-md-auto col-auto align-items-center">
      <span>
        <img
          src="../../../public/logo.png"
          :style="{ height: '3rem !important' }"
          class="ms-2 rounded"
        />
      </span>

      <span class="ms-3 text-white fw-semibold">
        {{ currentAppLabel }}
        <span class="badge bg-light text-dark ms-2">
          v{{ appVersion }}
        </span>
      </span>
    </div>

    <!-- 📰 News Section -->
    <div class="col-xl col-lg col-md col-4 d-xl-flex d-lg-flex d-md-flex d-none">
      <NewsTickerVue />
    </div>

    <!-- ⚙️ Action Buttons -->
    <div class="col-xl-auto col-lg-auto col-md-auto col justify-content-end d-flex align-items-center">
      <!-- Settings -->
      <button
        @click="$router.push({ name: 'settings-index' })"
        class="btn d-flex align-items-center px-2 py-2 text-white rounded"
        title="Settings"
      >
        <i class="bi bi-gear-wide-connected fs-3"></i>
      </button>

      <!-- Switch App -->
      <button
        @click="switchApp"
        class="btn d-flex align-items-center px-2 py-2 text-white rounded"
        title="Switch Application"
      >
        <i class="bi bi-arrow-left-right fs-3"></i>
      </button>

      <!-- Profile -->
      <button
        @click="toggleLogout"
        class="btn d-flex align-items-center px-2 py-2 text-white rounded"
        title="Profile"
      >
        <i class="bi bi-person-circle fs-3"></i>
        <span class="ms-1">{{ authData.name }}</span>
      </button>
    </div>

    <!-- 🔔 Notifications -->
    <div class="col-xl-auto col-lg-auto col-md-auto col-12">
      <AlertVue class="border" />
    </div>

    <!-- 🔓 Logout Dropdown -->
    <div
      v-if="logout_display"
      :style="{
        width: '200px',
        height: '100px',
        position: 'absolute',
        top: '4.3em',
        right: '10px',
        zIndex: 1000,
      }"
      class="position-absolute p-3 bg-white rounded shadow align-items-end"
    >
      <button @click="logout" class="btn btn-danger col-auto px-3 py-2">
        Déconnecter
      </button>
    </div>
  </div>
</template>

<script>
import NewsTickerVue from "../cards/NewsTicker.vue";
import AlertVue from "../../views/notification/Alert.vue";
import { mapGetters } from "vuex";
import constant from "../../constant";

export default {
  components: {
    NewsTickerVue,
    AlertVue,
  },
  data() {
    return {
      logout_display: false,
      appVersion: process.env.VUE_APP_VERSION || "1.0.0",
    };
  },
  computed: {
    ...mapGetters("auth", {
      authData: "getAuthData",
    }),
    currentAppLabel() {
      const host = window.location.hostname;
      if (host.includes("app5")) return "Management";
      if (host.includes("compta")) return "Accounting";
      return "Application";
    },
  },
  methods: {
    toggleLogout() {
      this.logout_display = !this.logout_display;
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    switchApp() {
      const currentHost = window.location.hostname;
      if (currentHost.includes("app5")) {
        window.location.href = constant.accountingAppUrl;
      } else {
        window.location.href = constant.managementAppUrl;
      }
    },
  },
};
</script>

<style scoped>
button {
  transition: background 0.2s ease;
}
button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.user-item {
  cursor: pointer;
  transition: background-color 0.2s;
}
.user-item:hover {
  background-color: #f8f9fa;
}
</style>
